import { useCallback } from 'react';
import { Trash } from 'lucide-react';
import { useLocation } from 'wouter';

import { Button } from '@monetr/interface/components/Button';
import { useCurrentLink } from '@monetr/interface/hooks/useCurrentLink';
import { showRemoveTransactionModal } from '@monetr/interface/modals/RemoveTransactionModal';
import type Transaction from '@monetr/interface/models/Transaction';

interface RemoveTransactionButtonProps {
  transaction: Transaction;
}

export default function RemoveTransactionButton(props: RemoveTransactionButtonProps): React.JSX.Element | null {
  const { transaction } = props;
  const { data: link } = useCurrentLink();
  const [, navigate] = useLocation();

  const promptRemoveTransaction = useCallback(async () => {
    return await showRemoveTransactionModal({
      transaction,
    }).then(() => navigate(`/bank/${transaction.bankAccountId}/transactions`));
  }, [navigate, transaction]);

  // We only allow removing transactions on manual links.
  if (!link?.getIsManual()) {
    return null;
  }

  return (
    <Button onClick={promptRemoveTransaction} variant='destructive'>
      <Trash />
      Remove
    </Button>
  );
}
